import config from '@iotv/config'
import {
  CoreApplicationObjectType,
  DatastoreObjectType,
  getObjectHash,
  POJOType
} from '@iotv/iotv-v3-types'
import { v5 } from 'uuid'
export { getObjectHash }

export const getV5Hash = (preHash: string) => v5(preHash, config.app.namespace_uuid)

const utfColon = '0x3A'
const utfUnderscore = '0x5F'
const utfHyphen = '0x2D'
export const getAcceptableDynamoDBKey = (str: string) => str.replace(/:/g, utfColon).replace(/-/g, utfHyphen)

export const getHydratedDatastoreKey = (dynamodbKey: string) => dynamodbKey.replace(new RegExp(utfColon, 'g'), ':').replace(new RegExp(utfHyphen, 'g'), '-')

/**
 * Function changes id, sk, pk and optionally type leaving pk unchanged if and edge
 * @param item
 * @param newId
 * @param newTypeId
 * @returns
 */
export const reKeyItem = <T extends DatastoreObjectType & { id: string; type: string }>(item: T, newId: string, newTypeId?: string): T => {
  let newKey = item.sk.replace(item.id, newId)
  if (newTypeId) newKey = newKey.replace(/^\S+:/, `${newTypeId}:`)
  if (item.sk === item.pk) {
    return { ...item, sk: newKey, pk: newKey, id: newId, type: newTypeId ?? item.type } //
  } else {
    return { ...item, sk: newKey, id: newId, type: newTypeId ?? item.type }
  }
}

//WIP
export const mungeObjectOrArr = (mungeFn: <TI, TO>(x: TI, y: TO) => TO, ob: POJOType) => {
  if (ob) {
    if (typeof ob === 'object' && !(ob instanceof Date) && !(ob instanceof Array)) {
      Object.keys(ob).reduce((acc, k) => {
        return mungeFn(ob[k as string], acc)
      }, undefined)
    } else if (ob instanceof Date) {
    } else if (ob instanceof Array) {
      Object.values(ob).reduce((acc, v) => {
        return mungeFn(v, acc)
      }, undefined)
    }
  }
}

export const summarizeList = (list: Record<string, any>[], maxNames: number = 5) => {
  let summary = `${list.length.toString()}`
  if (list.length < maxNames && list.every((item) => !!item.name)) {
    summary = list.map((item) => item.name).join(', ')
  }

  return summary
}


export const summarizeCoreApplicationObjects = (list: DatastoreObjectType[]): { [k: string]: number } => {
  const typeList: { [k: string]: number } = {}
  
  list.reduce( ( a, c ) => {
    const { type } = c as CoreApplicationObjectType
    if ( !typeList[type] ) typeList[type] = 0
    typeList[type]++
    return a 
  }, typeList )

  return typeList
}